/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment-timezone'
import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'

import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import { getEngineeringAuditConsequence } from 'plugin-codaf-risk-ext-bowtie/services/engineeringAudit'
import { IEngineeringAuditConsequenceReport, ISelectBowtie } from 'plugin-codaf-risk-ext-bowtie/types/engineeringAudit'
import { OrderFields } from 'plugin-codaf-risk-ext-bowtie/types/enums'

import { NoData, NoInfo } from '../../styles'

interface IProps {
    setItemsLength: (k: number) => void
    numberOfItems: number
    startDay: string | null
    endDay: string | null
    startHour: string | null
    endHour: string | null
    page: number
    setPage: (k: number) => void
    filterByResource: string
    filterByBowtie: ISelectBowtie
    limit: number
    searchString: string
}

interface IOrder {
    field: string
    order: boolean
}

export const EngineeringAuditConsequenceReport: React.FC<IProps> = ({
    setPage,
    setItemsLength,
    numberOfItems,
    startDay,
    startHour,
    endDay,
    endHour,
    page,
    filterByBowtie,
    filterByResource,
    limit,
    searchString
}) => {
    const [events, setEvents] = useState<IEngineeringAuditConsequenceReport>()
    const [isLoading, setIsLoading] = useState(false)

    const [order, setOrder] = useState<IOrder>({ field: OrderFields.DATE, order: true })

    const dateConverter = (data): string => {
        const newDate = new Date(data)
        const formatedDate = moment(newDate).format('YYYY/MM/DD, hh:mm:ss a')

        return `${formatedDate}`
    }

    const renderTableRow = (): JSX.Element[] => {
        if (events?.reports) {
            const renderObject = events?.reports.map((item, index) => {
                return (
                    <tr key={index} className={index === 0 && 'first-margin'}>
                        <td valign="middle">{dateConverter(item.date)}</td>
                        <td valign="middle">{item.consequenceId}</td>
                        <td valign="middle">{item.consequenceName}</td>
                        <td valign="middle">{i18n(item.finalFrequency)}</td>
                        <td valign="middle">{item.threshold}</td>
                        <td valign="middle">{item.bowtieName}</td>
                        <td valign="middle">{item.resource}</td>
                    </tr>
                )
            })

            return renderObject
        }
    }

    const dateFormatToRequisition = (dateToConvert): string => {
        const initialDateToRequisition = new Date(dateToConvert)
        const formatedInitialDate = moment(initialDateToRequisition).format('YYYY-MM-DD')

        return formatedInitialDate
    }

    const getEvents = async (): Promise<void> => {
        try {
            setIsLoading(true)
            const engineeringAuditEvents = await getEngineeringAuditConsequence(filterByBowtie?.value, {
                startDay: dateFormatToRequisition(startDay),
                startHour: startHour,
                endDay: dateFormatToRequisition(endDay),
                endHour: endHour,
                page: page,
                perPage: numberOfItems,
                sortBy: order.field,
                sortOrder: order.order ? 'ASC' : 'DESC',
                filterByResource: [filterByResource],
                filterByBowtieName: [filterByBowtie?.label],
                limit: limit.toString(),
                quickSearch: searchString
            })
            setEvents(engineeringAuditEvents)
            setItemsLength(engineeringAuditEvents.total)
        } catch (err) {
            globalNotification.error(err.message ?? i18n('An error occurred on list events.'))
        } finally {
            setIsLoading(false)
        }
    }

    const handleOrder = (field: string): void => {
        if (field === order.field) {
            setOrder({ field: order.field, order: !order.order })
        } else {
            setOrder({ field: field, order: true })
        }
    }

    useEffect(() => {
        getEvents()
    }, [startDay, startHour, endDay, endHour, page, order, limit, searchString])
    useEffect(() => {
        setPage(1)
    }, [order])

    return (
        <div className="tableContainer">
            <table>
                <thead>
                    <tr>
                        <th>
                            <Button onClick={() => handleOrder(OrderFields.DATE)}>
                                {i18n('date/time')}{' '}
                                {order.field === OrderFields.DATE && (
                                    <i className={`${order.order ? 'far fa-arrow-up' : 'far fa-arrow-down'}`} />
                                )}
                            </Button>
                        </th>
                        <th>
                            <Button onClick={() => handleOrder(OrderFields.CONSEQUENCE_ID)}>
                                {i18n('consequence id')}{' '}
                                {order.field === OrderFields.CONSEQUENCE_ID && (
                                    <i className={`${order.order ? 'far fa-arrow-up' : 'far fa-arrow-down'}`} />
                                )}
                            </Button>
                        </th>
                        <th>
                            <Button onClick={() => handleOrder(OrderFields.CONSEQUENCE_NAME)}>
                                {i18n('consequence name')}{' '}
                                {order.field === OrderFields.CONSEQUENCE_NAME && (
                                    <i className={` ${order.order ? 'far fa-arrow-up' : 'far fa-arrow-down'}`} />
                                )}
                            </Button>
                        </th>
                        <th>
                            <Button onClick={() => handleOrder(OrderFields.FINAL_FREQUENCY)}>
                                {i18n('final frequency')}{' '}
                                {order.field === OrderFields.FINAL_FREQUENCY && (
                                    <i className={`${order.order ? 'far fa-arrow-up' : 'far fa-arrow-down'}`} />
                                )}
                            </Button>
                        </th>
                        <th>
                            <Button onClick={() => handleOrder(OrderFields.THRESHOLD)}>
                                {i18n('threshold')}{' '}
                                {order.field === OrderFields.THRESHOLD && (
                                    <i className={`${order.order ? 'far fa-arrow-up' : 'far fa-arrow-down'}`} />
                                )}
                            </Button>
                        </th>
                        <th>
                            <Button onClick={() => handleOrder(OrderFields.BOWTIE_NAME)}>
                                {i18n('bowtie name')}{' '}
                                {order.field === OrderFields.BOWTIE_NAME && (
                                    <i className={`${order.order ? 'far fa-arrow-up' : 'far fa-arrow-down'}`} />
                                )}
                            </Button>
                        </th>
                        <th>
                            <Button onClick={() => handleOrder(OrderFields.RESOURCE)}>
                                {i18n('resource')}{' '}
                                {order.field === OrderFields.RESOURCE && (
                                    <i className={`${order.order ? 'far fa-arrow-up' : 'far fa-arrow-down'}`} />
                                )}
                            </Button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        <NoInfo>
                            <i className="fa fa-spinner fa-spin" />
                        </NoInfo>
                    ) : events?.total === 0 ? (
                        <NoData>{i18n('There is no data for the specified period.')}</NoData>
                    ) : (
                        renderTableRow()
                    )}
                </tbody>
            </table>
        </div>
    )
}
